import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2998_2312)" }, [
      _createElementVNode("path", {
        fill: "#464646",
        d: "M9.962 16.667c5.893 0 9.962-4.763 9.962-6.25 0-1.495-4.076-6.25-9.962-6.25-5.812 0-9.969 4.755-9.969 6.25 0 1.487 4.15 6.25 9.97 6.25m0-1.153c-4.805 0-8.693-4.07-8.693-5.097 0-.868 3.888-5.098 8.693-5.098 4.785 0 8.686 4.23 8.686 5.098 0 1.028-3.901 5.097-8.686 5.097m0-1.02a4.09 4.09 0 0 0 4.092-4.092 4.096 4.096 0 0 0-8.19 0 4.096 4.096 0 0 0 4.098 4.091m0-2.728a1.354 1.354 0 0 1-1.356-1.357c0-.75.605-1.356 1.356-1.356s1.357.605 1.357 1.356-.605 1.357-1.357 1.357"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2998_2312" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }